import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { BehaviorSubject, debounceTime, distinctUntilChanged, map, startWith } from 'rxjs';
import { VerifyCustomerService } from '../verify-customer.service';
import { MatTableDataSource } from '@angular/material/table';
import { KycStatusModel } from 'src/app/models/customer_master_model/company-model';
import { BackendListModel } from 'src/app/models/common/list.model';

@Component({
    selector: 'logzy-customer-table',
    templateUrl: './customer-table.component.html',
    styleUrls: ['../lead-table/lead-table.component.scss', './customer-table.component.scss']
})
export class CustomerTableComponent implements OnInit {
    searchTerm = '';
    searchText = new BehaviorSubject<string>('')
    refreshCustomerList: boolean = false;
    kycStatus;
    statusFilter;

    customerList: MatTableDataSource<BackendListModel<any>>;
    statusList: KycStatusModel[] = [];
    verifyModelService: VerifyCustomerService
    customerPageLength = 0;
    customerPageSize = 10;
    customerPageIndex = 0;
    loading: boolean = true;
    displayColumns = ['legal_name', 'address', 'country', 'kyc_status', 'last_action_on', 'action']

    part1: string = 'Just ';
    part2: string = 'checking ';
    part3: string = 'data.';

    @ViewChild(MatPaginator) paginator!: MatPaginator;

    constructor(private router: Router,
        private verifyCustomerService: VerifyCustomerService,
    ) { }

    ngOnInit(): void {
        this.resetComponent();
    }

    resetComponent() {
        this.verifyModelService = this.verifyCustomerService;
        this.getStatusList();

        this.searchText.pipe(
            startWith(''),
            distinctUntilChanged(),
            debounceTime(1000),
            map((searchText) => {
                if (searchText == '') {
                    this.getCustomerList();
                } else {
                    this.getCustomerList(searchText, this.kycStatus, this.customerPageSize, this.customerPageIndex)
                }
            })
        ).subscribe();
    }

    filterByApprovalStatus(status) {
        this.statusFilter = status;
        this.refreshCustomerList = true;
        this.kycStatus = status?.dev_name;
        this.getCustomerList(this.searchTerm, this.kycStatus, this.customerPageSize, this.customerPageIndex)
    }

    applyFilter(event) {
        this.paginator.firstPage();
        this.searchTerm = event;
        this.refreshCustomerList = true;
        this.searchText.next(event);
    }

    announceSortChange(sortState: Sort) {
        this.refreshCustomerList = true;
        switch (sortState.direction) {
            case 'asc':
                this.getCustomerList(this.searchTerm, this.kycStatus, this.customerPageSize, this.customerPageIndex, sortState.active);
                break;

            case 'desc':
                this.getCustomerList(this.searchTerm, this.kycStatus, this.customerPageSize, this.customerPageIndex, `-${sortState.active}`);
                break;

            default:
                this.getCustomerList(this.searchTerm, this.kycStatus, this.customerPageSize, this.customerPageIndex, null);
        }
    }

    pageChanged(event: PageEvent) {
        this.refreshCustomerList = true;
        this.customerPageSize = event.pageSize;
        this.customerPageIndex = event.pageIndex;
        this.getCustomerList(this.searchTerm, this.kycStatus)
    }

    getCustomerList(searchTerm = null, status = null, pageSize = null, pageIndex = null, ordering = '') {
        pageSize = pageSize || this.customerPageSize;
        pageIndex = pageIndex || this.customerPageIndex;

        this.verifyCustomerService.getCompanies(searchTerm, status, pageSize, pageIndex + 1, ordering).subscribe({
            next: res => {
                this.customerList = new MatTableDataSource(res.results);
                this.customerPageLength = res.count;
                this.loading = false;
                this.refreshCustomerList = false;
                if (res.results.length <= 0) {
                    this.part1 = 'No ';
                    this.part2 = 'data ';
                    this.part3 = 'found.';
                }
            }

        });
    }

    getStatusList() {
        this.verifyCustomerService.getKycStatusList().subscribe({
            next: res => {
                this.statusList = res.results;
                this.loading = false;
                this.refreshCustomerList = false;
            }
        });
    }

    viewCustomerMaster(element) {
        if (element.id != null) {
            this.router.navigateByUrl(`/verify-customer-kyc/kyc-details?id=${element.id}&country=${element.country?.id}`);
        }
    }

    closeDetails() {
        this.router.navigateByUrl(`dashboards/dashboard1`);
    }
}
